import { render, staticRenderFns } from "./TifTurnoDet.vue?vue&type=template&id=b77fb6cc"
import script from "./TifTurnoDet.vue?vue&type=script&lang=js"
export * from "./TifTurnoDet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports